import { observable, action } from "mobx";
import { Selection } from "../Selection";
/**
* Market defines model for market object information
*
* @typedef Market
* @type {Object}
* @property {id} Selection identifier
* @property {selections} Array of selections that are related to the current market
*/

export type MarketType = {
    id: string;
    lineGroupID?: string;
    isQA: boolean;
    typeID: string;
    typeName: string;
    selections: Selection[];
}

export class Market {
    id: string;
    lineGroupID?: string;
    isQA: boolean;
    typeID: string;
    typeName: string;
    @observable selections: Selection[];

    constructor(marketData: MarketType) {
        this.id = marketData.id;
        this.selections = marketData.selections;
        this.isQA = marketData.isQA;
        this.typeID = marketData.typeID;
        this.typeName = marketData.typeName;
        this.lineGroupID = marketData.lineGroupID;
    }

    @action.bound updateSelections(newSelections: any) {
        return this.selections = newSelections;
    }
}